export default __webpack_public_path__ + "static/media/uploading.212413cc.svg";